import { promptToPlainText } from "@seedance/contracts";
import { memo } from "react";
import { Handle, Position, type Node, type NodeProps } from "@xyflow/react";
import type { CanvasDocumentV3 as CanvasDocument } from "@seedance/contracts";
import type { BuildPreviewResult } from "@seedance/workflow";
import { useMeasuredHandles } from "./useMeasuredHandles.js";
import { canvasCopy } from "../../copy/zh-CN.js";

type SeedanceCanvasNode = Extract<CanvasDocument["nodes"][number], { kind: "seedance" }>;

export interface SeedanceNodeData extends Record<string, unknown> {
  canvasNode: SeedanceCanvasNode;
  label: string;
  refreshHandles?: boolean;
  preview?: BuildPreviewResult;
  referenceCounts: { image: number; video: number; audio: number };
}

export type SeedanceFlowNode = Node<SeedanceNodeData, "seedance">;

export const SeedanceNode = memo(function SeedanceNode({
  id,
  data,
  selected
}: NodeProps<SeedanceFlowNode>) {
  useMeasuredHandles(id, data.refreshHandles);
  const settings = data.canvasNode.settings;
  const summary = (data.preview?.finalPrompt || promptToPlainText(settings.prompt)).trim().replace(/\s+/gu, " ");
  return (
    <article className={`seedance-node${selected ? " seedance-node--selected" : ""}`}>
      <Handle type="target" position={Position.Left} />
      <header>
        <span>{canvasCopy.seedanceNode}</span>
        <strong className={data.preview?.ready ? "seedance-node__ready" : "seedance-node__error"}>
          {data.preview === undefined ? canvasCopy.loading : data.preview.ready ? canvasCopy.ready : canvasCopy.error}
        </strong>
      </header>
      <small>{settings.model}</small>
      <p>{summary || "尚未填写提示词"}</p>
      <div className="seedance-node__references">
        <span>图片 {data.referenceCounts.image}</span>
        <span>视频 {data.referenceCounts.video}</span>
        <span>音频 {data.referenceCounts.audio}</span>
      </div>
      <footer>
        <span>{settings.ratio}</span>
        <span>{settings.durationSeconds}s</span>
        <span>{settings.resolution}</span>
      </footer>
    </article>
  );
});
